<form #statusComments="ngForm" autocomplete="off" class="status-comments-form">

    <div class="modal-header status-comments-header">
        <div class="status-comments-heading">
            <span class="status-comments-heading__icon">
                <lucide-icon name="circle-check" [size]="19"></lucide-icon>
            </span>
            <div class="status-comments-heading__copy">
                <h5 class="modal-title" id="statusCommentTitle">{{ title }}</h5>
                <span class="status-comments-subtitle" *ngIf="showSubtitle">{{ objectName }}</span>
            </div>
        </div>
        <button type="button" class="close status-comments-close" (click)="cancel()"
                [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body status-comments-body" tabindex="0">

        <!-- Aprobaciones previas -->
        <app-ryd-formulas-approval-list [isModal]="false" [menuId]="statusChange.menu.id" [objectId]="objectId"
            [statusChange]="statusChange">
        </app-ryd-formulas-approval-list>

        <!-- Qué se está por confirmar -->
        <div class="status-comments-question" *ngIf="question" role="note">
            <lucide-icon name="info" [size]="18"></lucide-icon>
            <span>{{ question }}</span>
        </div>

        <!-- Comentario en los dos idiomas: al salir de uno se traduce al otro -->
        <div class="status-comments-card">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group mb-md-0">
                        <label class="form-label" for="comments">{{ 'COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate }} <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="name_es"><i class="flag-icon flag-icon-es"></i></span>
                            </div>
                            <textarea class="form-control" id="comments" rows="3" aria-describedby="name_es"
                                [placeholder]="('COMMON.PLACEHOLDER.INPUT' | translate) + ' ' + ('COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate)"
                                name="approvalComments" [(ngModel)]="approvalComments" required #comments="ngModel"
                                [class.error]="!comments.valid && statusComments.submitted"
                                (focusout)="translateInput(comments.name, comments.value)"></textarea>
                        </div>
                        <small *ngIf="statusComments.submitted && comments.errors?.required" class="form-text text-danger">
                            {{ 'COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate }} {{ 'COMMON.VALIDATIONS.REQUIRED' | translate }}
                        </small>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group mb-0">
                        <label class="form-label" for="commentsEn">{{ 'COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate }} <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="name_us"><i class="flag-icon flag-icon-us"></i></span>
                            </div>
                            <textarea class="form-control" id="commentsEn" rows="3" aria-describedby="name_us"
                                [placeholder]="('COMMON.PLACEHOLDER.INPUT' | translate) + ' ' + ('COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate)"
                                name="approvalCommentsEn" [(ngModel)]="approvalCommentsEnglish" required #commentsEn="ngModel"
                                [class.error]="!commentsEn.valid && statusComments.submitted"
                                (focusout)="translateInput(commentsEn.name, commentsEn.value, 'en', 'es')"></textarea>
                        </div>
                        <small *ngIf="statusComments.submitted && commentsEn.errors?.required" class="form-text text-danger">
                            {{ 'COMMON.STATUS_COMMENTS.MESSAGE.COMMENT' | translate }} {{ 'COMMON.VALIDATIONS.REQUIRED' | translate }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer status-comments-footer">
        <button [disabled]="loading" class="btn btn-primary status-comments-action" type="submit" rippleEffect
            (click)="onSubmit(statusComments)">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <lucide-icon *ngIf="!loading" name="circle-check" [size]="16"></lucide-icon>
            <span>{{ 'COMMON.BUTTONS.ACCEPT' | translate }}</span>
        </button>
        <button [disabled]="loading" class="btn btn-danger status-comments-action" type="submit" rippleEffect
            (click)="onReject(statusComments)">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <lucide-icon *ngIf="!loading" name="circle-x" [size]="16"></lucide-icon>
            <span>{{ 'COMMON.BUTTONS.REJECT' | translate }}</span>
        </button>
        <button type="button" class="btn btn-outline-primary status-comments-action" rippleEffect (click)="cancel()">
            <lucide-icon name="x" [size]="16"></lucide-icon>
            <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
        </button>
    </div>

</form>
